import { jsxs, jsx } from 'react/jsx-runtime';
import { Component } from 'react';
import api from '../WebRequest/WebRequest.js';
import '../Snackbar/index.js';
import { getRandomId } from '../Utils/baseComponentHelper.js';
import Snackbar from '../Snackbar/Snackbar.js';

/**
Il componente `FileUpload` permette l'upload di files,
wrappando un qualunque componente al suo interno che fungerà da trigger per l'upload.
 */
class FileUpload extends Component {
    constructor(props) {
        super(props);
        this.updateFiles = (e) => {
            const { allowUpload, max, multiple, onChange, onProgress, url, onFileUploaded, onCatch, uploader, } = this.props;
            const onChangeMultiple = multiple ? onChange : undefined;
            const files = e.target.files;
            for (let i = 0; i < files.length; i += 1) {
                const file = files[i];
                if (max && Math.ceil(file.size / 1000000) > max) {
                    Snackbar.show({ type: Snackbar.Types.ERROR, message: `Il file supera la dimensione massima accettata: ${max} MB` });
                    return;
                }
                let type = `.${file.name.split('.').pop()}`;
                if (type.indexOf('/') > -1) {
                    type = type.substr(type.indexOf('/') + 1);
                }
                if (this.extensionAccepted(type)) {
                    const formData = new FormData();
                    formData.append('file', file);
                    if ((allowUpload == null) || (allowUpload != null && allowUpload(file))) {
                        onChangeMultiple === null || onChangeMultiple === void 0 ? void 0 : onChangeMultiple(e, file);
                        this.uploadFile(url, file, formData, uploader, onProgress, onFileUploaded, onCatch);
                    }
                }
            }
            onChangeMultiple === null || onChangeMultiple === void 0 ? void 0 : onChangeMultiple(e);
        };
        this.extensionAccepted = (extension) => {
            const { accept } = this.props;
            if ((accept && (Array.isArray(accept) ? accept : [accept]).map((x) => x.toLowerCase())
                .indexOf(extension.toLowerCase()) === -1)) {
                Snackbar.show({ type: Snackbar.Types.ERROR, message: `Tipo di file non supportato: ${extension}` });
                return false;
            }
            return true;
        };
        this.uniqueid = getRandomId();
    }
    uploadFile(url, file, formData, uploader, onProgress, onFileUploaded, onCatch) {
        if (url) {
            uploader.postFile(url, formData, false, (evt) => {
                const progressPercent = (evt.loaded / evt.total);
                onProgress === null || onProgress === void 0 ? void 0 : onProgress(evt, progressPercent, file);
            })
                .then((res) => {
                this.refInput.value = '';
                onFileUploaded === null || onFileUploaded === void 0 ? void 0 : onFileUploaded(res.data, file);
            })
                .catch((err) => {
                this.refInput.value = '';
                onCatch === null || onCatch === void 0 ? void 0 : onCatch(err, file);
            });
        }
    }
    render() {
        const { children, accept, multiple, disabled, label, } = this.props;
        return (jsxs("div", { className: "upload", children: [jsx("div", { className: "upload__button", role: "presentation", onClick: () => !disabled && this.refInput.click(), children: children }), label && jsx("label", { htmlFor: this.uniqueid, className: "input__label", children: label }), jsx("input", { id: this.uniqueid, autoComplete: `fileupload-${this.uniqueid}`, disabled: disabled, multiple: multiple, accept: (accept && (Array.isArray(accept) ? accept : [accept]).map((x) => x).join(',')) || 'true', className: "upload__input", "data-origin": "fileupload", onChange: this.updateFiles, ref: (r) => { this.refInput = r; }, type: "file" })] }));
    }
}
FileUpload.defaultProps = {
    accept: '',
    allowUpload: null,
    children: null,
    max: 10240,
    multiple: false,
    onChange: null,
    onFileUploaded: null,
    onCatch: null,
    onProgress: null,
    disabled: false,
    url: null,
    label: null,
    uploader: api,
};

export { FileUpload as default };
